import React from "react";
import {Navbar,Footer} from '../hrcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams, useNavigate, useLocation} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const DocrInfo=()=>{

    const navigate=useNavigate();
    const location = useLocation();

    const [acrData,setAcrData]=useState([]);
    const [searchBy, setSearchBy] = useState('');
    const [inputData,setInputData]=useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isEditing, setIsEditing] = useState(false);
    const [empData,setEmpData]=useState([]);
    const [filterEmp, setFilterEmp] = useState([]);
    const [empID, setEmpId] = useState("");
    const [searchByEmpId,setSearchByEmpId]=useState("");

    useEffect(() => {
    const getAssetData = async () => {
          const res=await axios.get(configData.SERVER_URL+`/empDataAll`);
          setEmpData(res.data);
          setFilterEmp(res.data);
    };
    getAssetData();
  }, []);

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value}); 
    }

    const handleSearch = (e) => {
        setSearchBy(e.target.value);  
    };

    const handleSearchAcrData=async(e)=>{
        e.preventDefault();

        try {
            const res=await axios.get(configData.SERVER_URL+`/acrData/${searchByEmpId}`)
            setAcrData(res.data);
        } 
        catch (error) {
            console.error('Search error:', error);
        }   
    }

    const handleSearchAcrDataByYear=async(e)=>{
        e.preventDefault();

        try {
            const res=await axios.get(configData.SERVER_URL+`/acrDataByYear/${searchBy}`)
            setAcrData(res.data);
        } 
        catch (error) {
            console.error('Search error:', error);
        }   
    }

    const addTarget=()=>{
        setIsEditing(false);
        handleShow();
    }

    const editTarget=(data)=>{
        setIsEditing(true);
        setInputData(data);
        setEmpId(data.empID);
        handleShow();
    }

    const handleSubmitInsert=async(e)=>{
        e.preventDefault();
        const payload = {
        ...inputData,
        empID: empID   
        };
        let res=await axios.post(configData.SERVER_URL+'/acrDataPost',payload);
        if(res.status===200){
            setAcrData(res.data);
        } else{
        alert('System Error');
        } 
        handleClose();
    }

    const handleSubmitEdit =async(e) => {
        e.preventDefault(); 
        try {
            const payload = {
            ...inputData,
            empID: empID   
            };
            let res=await axios.post(configData.SERVER_URL+`/acrDataEdit`,payload);
            if(res.status===200){
                if(res.data===1){
                alert('Successfully Updated');
                const res=await axios.get(configData.SERVER_URL+`/acrData/${inputData.empNID}`)
                setAcrData(res.data);
                }
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const empOptions = filterEmp.map(d => ({
    value: String(d.id),
    label: `${d.branchcode}->${d.empCode} : ${d.empName} : ${d.NID}`
    }));


    return (
  <>
    <div
      className="container-fluid">

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        style={{marginTop:50}}
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(135deg,#0d6efd,#6610f2)",
            color: "#fff",
          }}
        >
          <Modal.Title className="fw-bold">
            {isEditing ? "Edit" : "Insert"} DOCR / ACR
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            backgroundColor: "#f8f9fa",
          }}
        >
          <Form
            onSubmit={
              isEditing
                ? handleSubmitEdit
                : handleSubmitInsert
            }
          >
            <div className="row g-3">
              {/* Employee */}
              <div className="col-12">
                <Form.Label className="fw-semibold">
                  Employee Information
                </Form.Label>

                <Select
                  options={empOptions}
                  isSearchable
                  value={empOptions.find( (opt) =>String(opt.value) === String(empID) )}
                  placeholder="Search Employee..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "45px",
                      borderRadius: "10px",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  onChange={(selectedOption) => { setEmpId( selectedOption ? selectedOption.value : null); }}
                />
              </div>

              {/* ACR Date */}
              <div className="col-lg-6">
                <Form.Label className="fw-semibold">
                  ACR Date From
                </Form.Label>

                <Form.Control
                  type="date"
                  id="acrDateFrom"
                  name="acrDateFrom"
                  onChange={handleInput}
                  value={inputData.acrDateFrom}
                  required
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              <div className="col-lg-6">
                <Form.Label className="fw-semibold">
                  ACR Date To
                </Form.Label>

                <Form.Control
                  type="date"
                  id="acrDateTo"
                  name="acrDateTo"
                  onChange={handleInput}
                  value={inputData.acrDateTo}
                  required
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Designation */}
              <div className="col-lg-6">
                <Form.Label className="fw-semibold">
                  Designation
                </Form.Label>

                <Form.Control
                  type="text"
                  id="empDesignation"
                  name="empDesignation"
                  placeholder="Enter Designation"
                  onChange={handleInput}
                  value={inputData.empDesignation}
                  required
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* DOCR Date */}
              <div className="col-lg-6">
                <Form.Label className="fw-semibold">
                  DOCR Entry Date
                </Form.Label>

                <Form.Control
                  type="date"
                  id="docrEntryDate"
                  name="docrEntryDate"
                  onChange={handleInput}
                  value={inputData.docrEntryDate}
                  required
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                  }}
                />
              </div>

              {/* Submit */}
              <div className="col-12 mt-3">
                <Button
                  variant={
                    isEditing
                      ? "primary"
                      : "success"
                  }
                  type="submit"
                  className="px-4 py-2"
                  style={{
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                >
                  {isEditing ? (
                    <>
                      <Icon.PencilSquare className="me-2" />
                      Update Record
                    </>
                  ) : (
                    <>
                      <Icon.CheckCircle className="me-2" />
                      Submit Record
                    </>
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Main Card */}
      <div
        className="card border-0 shadow-lg"
        style={{
          borderRadius: "20px",
          overflow: "visible",
        }}
      >
        {/* Header */}
        <div
          className="card-header"
          style={{
            background:
              "linear-gradient(135deg,#198754,#20c997)",
            color: "#fff",
            padding: "22px",
          }}
        >
          <div className="d-flex align-items-center">
            <Icon.FileEarmarkTextFill
              size={28}
              className="me-3"
            />

            <div>
              <h3 className="fw-bold mb-1">
                ACR Information
              </h3>

              <small>
                Employee ACR & Dossier Management
              </small>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="card-body" style={{ backgroundColor: "#f8f9fa", padding: "30px",}}>
          {/* Search Section */}
          <div className="row g-4 align-items-end">
            {/* Search Employee */}
            <div className="col-lg-6">
              <label className="form-label fw-semibold">
                Search By Employee
              </label>

              <Select
                options={empOptions}
                isSearchable
                placeholder="Search by Name / Code / NID"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(selectedOption) => {
                  setSearchByEmpId( selectedOption ? selectedOption.value : null);
                }}
              />
            </div>

            {/* Search Button */}
            <div className="col-lg-2">
              <button type="button"  className="btn btn-primary w-100 shadow-sm"
                onClick={(e) => handleSearchAcrData(e) }
                style={{  borderRadius: "10px", height: "45px", fontWeight: "600",}}
              >
                <Icon.Search className="me-2" />
                Search
              </button>
            </div>

            {/* Add Button */}
            <div className="col-lg-2">
              <button type="button" className="btn btn-success w-100 shadow-sm"
                onClick={() => { addTarget(); }}
                style={{ borderRadius: "10px", height: "45px", fontWeight: "600", }}
                disabled={location?.state?.menu?.isInsert !== "Y"}
              >
                <Icon.PlusCircle className="me-2" />
                Add New
              </button>
            </div>
          </div>

          {/* Search by Year */}
          <div className="row g-4 mt-2 align-items-end">
            <div className="col-lg-4">
              <label className="form-label fw-semibold">
                Search By Year
              </label>

              <input
                type="search"
                className="form-control shadow-sm"
                id="searchBy"
                name="searchBy"
                placeholder="Enter ACR Year"
                value={searchBy}
                onChange={(e) => { handleSearch(e);}}
                style={{ borderRadius: "10px", height: "45px",}}
              />
            </div>

            <div className="col-lg-2">
              <button type="button"  className="btn btn-dark w-100 shadow-sm"
                onClick={(e) => handleSearchAcrDataByYear(e)}
                style={{ borderRadius: "10px", height: "45px", fontWeight: "600", }}
              >
                <Icon.Calendar3 className="me-2" />
                Search
              </button>
            </div>
          </div>

          <hr className="my-4" />

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle">
              <thead
                style={{
                  backgroundColor: "#198754",
                  color: "#fff",
                }}
              >
                <tr>
                  <th style={{width:50}}>SL</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>NID</th>
                  <th>ACR Year</th>
                  <th>Date From</th>
                  <th>Date To</th>
                  <th>DOCR Date</th>
                </tr>
              </thead>

              <tbody>
                {acrData &&
                  acrData.length > 0 &&
                  acrData.map(
                    (data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td>
                          <div className="fw-semibold">
                            {data.empCode}
                          </div>

                          <small className="text-muted">
                            {data.empName}
                          </small>
                        </td>

                        <td><small> { data.empDesignation }</small></td>

                        <td>{data.NID}</td>
                        <td>{data.acrYear}</td>

                        <td>
                          {data.acrDateFrom ? format( new Date(data.acrDateFrom),"dd-MM-yyyy") : ""}
                        </td>

                        <td>
                          {data.acrDateTo ? format(new Date(data.acrDateTo),"dd-MM-yyyy") : ""}
                        </td>

                        <td>
                          {data.docrEntryDate ? format( new Date( data.docrEntryDate), "dd-MM-yyyy") : ""}
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            {acrData.length === 0 && (
              <div className="alert alert-warning text-center mt-3">
                No ACR information found.
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  </>
);
}

export default DocrInfo;